// extracted by mini-css-extract-plugin
export default {"loader":"bigLoader_loader__Mwieh","spin":"bigLoader_spin__X5dBt"};